import { resetCliImmediateShutdownForTests } from '../../runtime/cli-process-interrupt.js';
import { resetSymbolIndexWorkerShutdownForTests } from '../../code-nav/symbol-index/worker/shutdown-state.js';
import { resetCodeNavCacheAvailabilityForTests } from './code-nav-cache-availability.js';
import { resetCodeNavCacheLogForTests } from './code-nav-cache-log.js';
import { resetCodeNavCacheAccessDepth } from './code-nav-cache-access-depth.js';
import {
  closeAllCodeNavCacheSqliteConnections,
  withCodeNavCacheSqliteSyncWrapped,
  withCodeNavCacheSqliteWorkLockProbeWrapped,
  withCodeNavCacheSqliteWorkLockWrapped,
} from './code-nav-cache-wrapped-access.js';

export {
  codeNavCacheSqlite,
  closeAllCodeNavCacheSqliteConnections,
  withCodeNavCacheSqliteSyncWrapped,
  withCodeNavCacheSqliteWorkLockProbeWrapped,
  withCodeNavCacheSqliteWorkLockWrapped,
} from './code-nav-cache-wrapped-access.js';

export function closeCodeNavCacheDatabaseForTests(): void {
  resetCliImmediateShutdownForTests();
  closeAllCodeNavCacheSqliteConnections();
  resetCodeNavCacheAccessDepth();
  resetCodeNavCacheAvailabilityForTests();
  resetCodeNavCacheLogForTests();
  resetSymbolIndexWorkerShutdownForTests();
}
